export const getAvailableTerraProviderTypes = (availableTypes: string[] | null | undefined) =>
  availableTypes || []
